import React from "react";

/**
 * Loading Spinner Component
 *
 * A reusable loading spinner component with consistent styling.
 * Used across the application for loading states.
 *
 * @param {string} size - Size of the spinner ('sm', 'md', 'lg') - defaults to 'md'
 * @param {string} color - Color theme ('white', 'blue', 'violet') - defaults to 'white'
 * @param {string} className - Optional additional CSS classes
 */
const LoadingSpinner = ({ size = "md", color = "white", className = "" }) => {
  const sizeClasses = {
    sm: "w-4 h-4",
    md: "w-5 h-5",
    lg: "w-8 h-8",
  };

  const colorClasses = {
    white: "border-white border-t-transparent",
    blue: "border-blue-400 border-t-transparent",
    violet: "border-violet-400 border-t-transparent",
  };

  return (
    <div
      className={`border-2 rounded-full animate-spin ${sizeClasses[size]} ${colorClasses[color]} ${className}`}
    />
  );
};

export default LoadingSpinner;
